import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { clueAuditList, salesClueDetail } from '@/api/overseasSales/clueManage'
import { clueTypeEnum } from '@/views/overseasSales/clueManage/dataConfig'
import applyModel from './applyModel.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import type { SalesClueListItem } from '@/typings/api/clueManage'


const __default__ = { name: 'DcCosOFbuCluesAudit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()

const tableRef = ref()
const selectedRows = ref<SalesClueListItem[]>([])
const queryForm = ref({
  auditStatus: 1,
  contact: {
    type: 1
  }
})
const applyModelRef = ref()
const applyStateEnum = computed(() => [
  { label: t('operate.sukg7w'), value: 1 },
  { label: t('operate.cfq4cr'), value: 2 },
  { label: t('operate.fvmvfe'), value: 3 }
])
const stateColorEnum = computed(() => [
  {
    name: t('operate.sukg7w'),
    value: 1,
    color: '#1d4cd2'
  },
  {
    name: t('operate.cfq4cr'),
    value: 2,
    color: '#3FAC46'
  },
  {
    name: t('operate.fvmvfe'),
    value: 3,
    color: '#DF443B'
  }
])
const fetch = (params: object, callBack: (res: any) => void) => {
  clueAuditList({
    ...params
  }).then((res) => {
    callBack(res)
  })
}
// 获取详情联系人信息
const showMask = (record: SalesClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId }).then((res) => {
    const { contact } = res.data
    callBack({
      contactName: contact.name,
      contactMobile: contact.mobile
    })
  })
}
const onSelectRowsChange = (keys: string[], rows: SalesClueListItem[]) => {
  selectedRows.value = rows
}
// 待审核&&当前
const getCheckboxProps = (record: SalesClueListItem) => ({
  disabled: !(record.auditStatus === 1), // Column configuration not to be checked
  auditStatus: record.auditStatus
})

const success = () => {
  tableRef.value.fetch()
}
const search = () => {
  tableRef.value.fetch()
}
const handleAppaly = (row?: SalesClueListItem) => {
  let data: any = []
  if (row && row.clueId) {
    data.push(row)
  } else {
    data = selectedRows.value
  }
  applyModelRef.value.toggle(data)
}
const columns = computed(() => [
  {
    title: t('operate.r1nt24'),
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/ofbu/salesClue/view',
    query: ['clueId', 'recordId', 'isApplay=1'],
    fixed: 'left'
  },
  {
    title: t('operate.6ihqzi'),
    dataIndex: 'createByName'
  },
  {
    title: t('operate.comzhy'),
    dataIndex: 'applyTime'
  },
  {
    title: t('operate.42ahj4'),
    dataIndex: 'applyReason'
  },
  {
    title: t('operate.aayuli'),
    dataIndex: 'auditorName'
  },
  {
    title: t('operate.5n66zv'),
    dataIndex: 'auditTime',
    width: 150
  },
  {
    title: t('operate.moulyj'),
    dataIndex: 'auditStatus'
  },
  {
    title: t('operate.gal9fo'),
    dataIndex: 'contactName',
    cosType: 'mask'
  },
  {
    title: t('operate.3eogpd'),
    dataIndex: 'contactMobile',
    cosType: 'mask'
  },
  {
    title: t('operate.mzmxr7'),
    dataIndex: 'customerRegion'
  },
  {
    title: t('operate.1lpu94'),
    dataIndex: 'clueType',
    dicData: clueTypeEnum
  },
  {
    title: t('operate.s0owdr'),
    dataIndex: 'beforeFollowerName'
  },
  {
    title: t('operate.ihxkbd'),
    width: 150,
    dataIndex: 'clueCreateTime'
  },
  {
    title: t('common.action'),
    dataIndex: 'action',
    width: 100,
    fixed: 'right'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            onMask: showMask,
            rowKey: "recordId",
            "row-selection": { onChange: onSelectRowsChange, getCheckboxProps: getCheckboxProps },
            search: queryForm.value,
            "onUpdate:search": _cache[11] || (_cache[11] = ($event: any) => ((queryForm).value = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosOFbuApprovalClue"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "auditStatus",
                    label: _unref(t)('operate.moulyj')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: queryForm.value.auditStatus,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.auditStatus) = $event)),
                        optionType: "button",
                        onChange: search,
                        options: [{ label: _unref(t)('common.all'), value: undefined }, ...applyStateEnum.value]
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('operate.r1nt24')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.customerName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.customerName) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "contactName",
                    label: _unref(t)('operate.gal9fo')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.contact.name,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.value.contact.name) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('operate.3eogpd')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.contact.keyword,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.value.contact.keyword) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "applicant",
                    label: _unref(t)('operate.6ihqzi')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: queryForm.value.applicant,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.value.applicant) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('operate.comzhy')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.value.startApplyTime,
                        "onUpdate:startTime": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.value.startApplyTime) = $event)),
                        endTime: queryForm.value.endApplyTime,
                        "onUpdate:endTime": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.value.endApplyTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "auditor",
                    label: _unref(t)('operate.aayuli')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: queryForm.value.auditor,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.value.auditor) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('operate.5n66zv')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.value.startAuditTime,
                        "onUpdate:startTime": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.value.startAuditTime) = $event)),
                        endTime: queryForm.value.endAuditTime,
                        "onUpdate:endTime": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.value.endAuditTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'auditStatus')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 0,
                    enums: stateColorEnum.value,
                    value: text
                  }, null, 8, ["enums", "value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerRegion')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 1,
                    appId: "cos_ofbu",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 2 }, {
                    default: _withCtx(() => [
                      (record.auditStatus === 1)
                        ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "link",
                            onClick: ($event: any) => (handleAppaly(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.review')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_permission, 'ofbu_cluesaudit_check_btn']
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (handleAppaly()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.batchReview')), 1)
                ]),
                _: 1
              })), [
                [_directive_permission, 'ofbu_cluesaudit_check_btn']
              ])
            ]),
            _: 1
          }, 8, ["columns", "row-selection", "search"]),
          _createVNode(applyModel, {
            ref_key: "applyModelRef",
            ref: applyModelRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})